
<template>
  <div class="dictionary clearfix">
    <div class="dictionary-left">
      <el-row class="dictionary-row">
        <el-col :span=7>
          <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
              style="vertical-align:middle;"></span>
          <span style="height:54px;line-height:54px;font-size:16px;">{{ dictionary.dataDictionary }}</span>
        </el-col>
        <el-col :span=3 :offset=14>
        </el-col>
      </el-row>
      <el-row style="width:90%;margin:10px auto;">
        <el-tree :data="treeList" node-key="id" default-expand-all :expand-on-click-node="false"
          @node-click="handleNodeDictionary" :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <!-- type==0 文件夹 可以在下面添加字典项 显示  type==1常量  不能在下面添加字典项 隐藏 -->
              <el-button v-if="data.type == 0" type="text" size="mini" @click="() => appendDictionary(data)">
                <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor">
              </el-button>
              <!-- 固定的两项 data.id==1和data.id==2不能修改和删除 只能在此基础上去添加-->
              <el-button v-if="data.id != 1 && data.id != 2" type="text" size="mini" @click="() => editDictionary(data)">
                <img src="@/assets/beadhouse/bianji_icon.png" alt="" class="vertical-align-cursor">
              </el-button>
              <!-- 固定的两项 data.id==1和data.id==2不能修改和删除 只能在此基础上去添加-->
              <el-button v-if="data.id != 1 && data.id != 2" type="text" size="mini"
                @click="() => removeDictionary(node, data)">
                <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="vertical-align-cursor">
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-row>
    </div>
    <div class="dictionary-right">
      <el-row>
        <el-row class="dictionary-row">
          <el-col :span=2>
            <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
                style="vertical-align:middle;"></span>
          </el-col>
          <el-col :span=4 :offset=9 style='font-size:16px;'>{{ dictionary.dictionaryManagement }}</el-col>
          <el-col :span=2 :offset=7 align=center>
            <!-- <span class="dictionary-row-span-ml">
              <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor">
            </span> -->
          </el-col>
        </el-row>
      </el-row>
      <el-row style="margin-top:10px;">
        <!--表格内容栏-->
        <el-table border :data="tableData" :header-cell-style="tableHeaderColor" style="width: 100%">
          <el-table-column prop="id" label="字典编号" min-width="150" align=center></el-table-column>
          <el-table-column prop="dictValue" label="值" min-width="180" align=center></el-table-column>
          <el-table-column prop="dictKey" label="名称" min-width="200" align=center></el-table-column>
          <el-table-column label="操作" min-width="180" align=center>
            <template slot-scope="scope">
              <img src="@/assets/beadhouse/bianji_icon.png" alt="" class="imgSize"
                @click="EditRow(scope.$index, scope.row)">
              <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="imgSize"
                @click="deleteRow(scope.$index, scope.row)">
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
    <!-- 新增 和  修改  字典的dialog模态框-->
    <el-dialog :title="operation ? dictionary.newDataDictionary : dictionary.editDataDictionary" width="35%"
      :visible.sync="dialogVisibleDictionaryForm" :close-on-click-modal="false" @close="closeDictionaryDialog">
      <el-form :model="dictionaryForm" label-width="120px" :rules="dictionaryFormRules" ref="dictionaryForm"
        label-position="right">
        <el-form-item :label="dictionary.dictionaryType" prop="type">
          <el-select v-model.trim="dictionaryForm.type" :placeholder="dictionary.pleaseEnterDictionaryType"
            style="width:80%">
            <el-option value="0" :label="dictionary.folder"></el-option>
            <el-option value="1" :label="dictionary.constant"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="dictionary.dictionaryTypeName" prop="dictName">
          <el-input v-model.trim="dictionaryForm.dictName" auto-complete="off"
            :placeholder="dictionary.pleaseEnterDictionaryTypeName" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item :label="dictionary.dictionaryTypeCode" prop="dictCode">
          <el-input v-model.trim="dictionaryForm.dictCode" auto-complete="off"
            :placeholder="dictionary.pleaseEnterDictionaryTypeCode" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item :label="dictionary.dictionaryItemName" prop="dictKey">
          <el-input v-model.trim="dictionaryForm.dictKey" auto-complete="off"
            :placeholder="dictionary.pleaseEnterDictionaryItemName" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item :label="dictionary.dictionaryValue" prop="dictValue">
          <el-input v-model.trim="dictionaryForm.dictValue" auto-complete="off"
            :placeholder="dictionary.pleaseEnterDictionaryValue" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item :label="dictionary.dictionaryTypeDescription" prop="remark">
          <el-input v-model.trim="dictionaryForm.remark" type="textarea" :rows=4 auto-complete="off"
            :placeholder="dictionary.pleaseEnterDictionaryTypeDescription" style="width:80%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleDictionaryForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitDictionaryForm"
          :loading="dictionaryFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable"
import KtButton from "@/components/KtButton"
export default {
  name: 'Dictionary',
  components: { KtTable, KtButton, },
  data() {
    return {
      operation: true,//默认是true  点击dialog显示的是新字典的dialog模态框
      size: 'medium',//按钮的尺寸
      dictionary: {
        dataDictionary: "数据字典",
        dictionaryManagement: "字典管理",
        newDataDictionary: "新增数据字典",
        editDataDictionary: "修改数据字典",
        deleteDataDictionary: "删除数据字典",
        dictionaryTypeName: "字典类型名称",
        dictionaryTypeCode: "字典类型编码",
        dictionaryItemName: "字典项名称",
        dictionaryValue: "字典项值",
        dictionaryType: "类型",
        dictionaryTypeDescription: "字典类型描述",
        pleaseEnterDictionaryTypeName: "请输入字典类型名称",
        pleaseEnterDictionaryTypeCode: "请输入字典类型编码",
        pleaseEnterDictionaryItemName: "请输入字典项名称",
        pleaseEnterDictionaryValue: "请输入字典项值",
        pleaseEnterDictionaryTypeDescription: "请输入字典类型描述",
        pleaseEnterDictionaryType: "请选择类型",
        notEmpty: "不能为空",
        loading: "加载中...",
        constant: "常量",
        folder: "文件夹"
      },//引入 lang 里面的字符串资源
      id: "",//当前菜单的id  默认显示第一个tree的菜单  
      pid: "",//父级的id
      treeList: [],//字典树
      defaultProps: {
        children: 'children',
        label: 'dictName'
      },
      //新增和修改字典的dialog模态框的配置
      dialogVisibleDictionaryForm: false,//dialog模态框默认为隐藏
      dictionaryFormLoading: false,//新增和修改的确定按钮加载的loading  默认为false 不加载 
      dictionaryForm: {},//新增字典数据源
      dictionaryFormRules: {//验证的匹配规则
        type: [
          { required: true, message: "不能为空", trigger: 'change' },
        ],
        dictName: [
          { required: true, message: "不能为空", trigger: 'blur' },
        ],
        dictCode: [
          { required: true, message: "不能为空", trigger: 'blur' },
        ],
        dictKey: [
          { required: true, message: "不能为空", trigger: 'blur' },
        ],
        dictValue: [
          { required: true, message: "不能为空", trigger: 'blur' },
        ],
        remark: [
          { required: true, message: "不能为空", trigger: 'blur' },
        ],
      },
      loading: false,//表格加载的loading
      tableData: [],
    }
  },
  methods: {
    /* 
        关闭新增和修改字典的dialog
    */
    closeDictionaryDialog() {
      this.$nextTick(() => {
        if (this.$refs.dictionaryForm) {
          this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
        }
      })
    },

    /* 
      点击tree树
    */
    handleNodeDictionary(data, node, vuecomponent) {
      console.log(data, node, vuecomponent);
      let id = data.id;
      this.queryDictAndSubById(id);
    },

    /* 
      新增字典 弹出dialog模态框
    */
    appendDictionary(data) {
      console.log(data);
      this.id = data.id;
      this.pid = data.pid;
      console.log(this.id, this.pid);
      this.operation = true;//true 新增的
      this.dialogVisibleDictionaryForm = true;//dialog模态框打开
      this.dictionaryForm = {
        type: "",
        dictName: "",
        dictCode: "",
        dictKey: "",
        dictValue: "",
        remark: "",
      }
    },

    /* 
      修改字典 弹出dialog模态框
    */
    editDictionary(data) {
      console.log(data);
      this.id = data.id;
      this.pid = data.pid;
      console.log(this.id, this.pid);
      this.operation = false;//修改的
      this.dialogVisibleDictionaryForm = true;//dialog模态框打开
      this.dictionaryForm.type = String(data.type);
      this.dictionaryForm.dictName = data.dictName;
      this.dictionaryForm.dictCode = data.dictCode;
      this.dictionaryForm.dictKey = data.dictKey;
      this.dictionaryForm.dictValue = data.dictValue;
      this.dictionaryForm.remark = data.remark;
      console.log(this.dictionaryForm);
    },

    /* 
        新增 和  修改 字典提交数据
    */
    submitDictionaryForm() {
      this.$refs.dictionaryForm.validate((valid) => {
        if (valid) {
          let params = {};
          params = Object.assign({}, this.dictionaryForm);//拷贝需要提交的数据源
          console.log(this.operation);
          if (this.operation == false) {//修改的时候需要传id
            params.id = this.id;
            params.pid = this.pid;
          } else {
            if (this.id != '') {
              params.pid = this.id;
            } else {
              params.pid = 1;
            }
          }
          console.log(params);
          this.dictionaryFormLoading = true;//确定按钮loadin为true;
          this.$postJson("mdc/dict/save", params).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.operation = true;//重置状态为true
            this.dictionaryFormLoading = false;//loading隐藏
            this.dialogVisibleDictionaryForm = false;//dialog模态框关闭
            this.getTree();//刷新字典树
            this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
          })
        }
      })
    },

    /* 
      删除字典 弹出dialog模态框
    */
    removeDictionary(node, data) {
      console.log(node, data);
      console.log(node, data);
      this.$confirm('确认删除字典项吗？', '删除字典', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$postForm("mdc/dict/deleteById/" + data.id).then((res) => {
          console.log(res);
          this.getTree();//刷新字典树
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },

    /* 
      查询字典树
    */
    getTree() {
      this.treeList = [];
      this.$postForm('mdc/dict/getTree').then(res => {
        console.log(res, "查询树");
        if (res.code == 200) {
          if (res.result.length > 0) {
            res.result.forEach((item, index) => {
              console.log(item);
              if (index == 0) {
                this.id = item.id;
              }
            })
            this.treeList = res.result;
            console.log(this.treeList, "字典树的数组");
            this.queryById(this.id);
            this.queryDictAndSubById(this.id);
          }
        }
      })
    },

    /* 
      根据Id查询字典详情
    */
    queryById(id) {
      this.$postForm("mdc/dict/queryById/" + id).then(res => {
        console.log(res);
      })
    },

    /* 
      根据id查询字典已经字典列表
    */
    queryDictAndSubById(id) {
      this.tableData = [];
      this.$postForm("mdc/dict/queryDictAndSubById/" + id).then(res => {
        console.log(res);
        this.tableData.push(res.result);
      })
    },

    /* 
      表格中的编辑
    */
    EditRow(index, row) {
      if (row.id != 1 && row.id != 2) {
        this.id = row.id;
        this.pid = row.pid;
        console.log(this.id, this.pid);
        this.operation = false;//修改的
        this.dialogVisibleDictionaryForm = true;//dialog模态框打开
        this.dictionaryForm.type = String(row.type);
        this.dictionaryForm.dictName = row.dictName;
        this.dictionaryForm.dictCode = row.dictCode;
        this.dictionaryForm.dictKey = row.dictKey;
        this.dictionaryForm.dictValue = row.dictValue;
        this.dictionaryForm.remark = row.remark;
        console.log(this.dictionaryForm);
      } else {
        this.$message({ message: "此字典项不能修改", type: "error" });
      }
    },

    /* 
      表格中的删除
    */
    deleteRow(index, row) {
      console.log(index, row);
      if (row.id != 1 && row.id != 2) {
        this.$confirm('确认删除字典项吗？', '删除字典', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$postForm("mdc/dict/deleteById/" + row.id).then((res) => {
            console.log(res);
            this.getTree();//刷新字典树
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
      } else {
        this.$message({ message: "此字典项不能删除", type: "error" });
      }
    },

    /* 
      修改表格的头部颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color:rgb(206, 203, 203);color:#6f7075;font-weight: 700;height:50px;'
      }
    },
  },
  created() {

  },
  mounted() {
    this.getTree();
  },
}
</script>
<style lang="scss" scoped>
.dictionary {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  background: #FEFEFE;

  .dictionary-left {
    float: left;
    width: 22%;
    height: 100%;
    border: 1px #F1EFF2 solid;
    margin-right: 2%;
    box-sizing: border-box;
    min-height: 500px;
  }

  .dictionary-right {
    float: right;
    width: 74%;
    height: 100%;
    margin-right: 2%;
    box-sizing: border-box;
  }

  .dictionary-row {
    height: 54px;
    line-height: 54px;
    background: rgb(245, 243, 247);
    border: 1px #F1EFF2 solid;
  }

  .dictionary-row-span-ml {
    height: 54px;
    line-height: 54px;
    margin-left: 10px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .vertical-align-cursor {
    vertical-align: middle;
    cursor: pointer;
    width: 15px;
    height: 15px;
  }

  .imgSize {
    vertical-align: middle;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
}</style>

